// extracted by mini-css-extract-plugin
export default {"botoes":"VersoesIndex_botoes__9R78l","barra":"VersoesIndex_barra__3fIQR","td":"VersoesIndex_td__FFBaK"};